var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarketplace({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 36,
    viewBox: "0 0 34 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.30001 0.0999756C1.14021 0.0999756 0.200012 1.04018 0.200012 2.19998C0.200012 3.35977 1.14021 4.29998 2.30001 4.29998H4.86038L5.50206 6.86668C5.50879 6.89636 5.51616 6.9258 5.52413 6.95499L8.37432 18.3557L6.49991 20.2301C3.85406 22.876 5.72795 27.4 9.46976 27.4H27.4999C28.6597 27.4 29.5999 26.4598 29.5999 25.3C29.5999 24.1402 28.6597 23.2 27.4999 23.2L9.46976 23.2L11.5698 21.1H25.4C26.1954 21.1 26.9226 20.6506 27.2783 19.9391L33.5783 7.33912C33.9038 6.68815 33.869 5.91506 33.4864 5.29594C33.1037 4.67683 32.4278 4.29998 31.7 4.29998H9.18964L8.53731 1.69065C8.3036 0.7558 7.46363 0.0999756 6.50001 0.0999756H2.30001Z",
    fill: "#9F9C96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6 32.65C29.6 34.3897 28.1897 35.8 26.45 35.8C24.7103 35.8 23.3 34.3897 23.3 32.65C23.3 30.9103 24.7103 29.5 26.45 29.5C28.1897 29.5 29.6 30.9103 29.6 32.65Z",
    fill: "#9F9C96"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65001 35.8C11.3897 35.8 12.8 34.3897 12.8 32.65C12.8 30.9103 11.3897 29.5 9.65001 29.5C7.91031 29.5 6.50001 30.9103 6.50001 32.65C6.50001 34.3897 7.91031 35.8 9.65001 35.8Z",
    fill: "#9F9C96"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplace);
export default __webpack_public_path__ + "static/media/marketplace.25a370f4.svg";
export { ForwardRef as ReactComponent };